// Consulting site brand tokens and contact details
export const brand = {
  ink: '#111318',
  panel: '#1A1D24',
  line: '#2A2E37',
  lineStrong: '#3A3F4A',
  text: '#ECEDEF',
  textStrong: '#FFFFFF',
  textBody: '#B9BEC8',
  textSoft: '#D4D7DD',
  textMuted: '#9096A2',
  accent: '#F5C518',
  accentInk: '#2A2B2E',
  warn: '#FF8A4C',
  light: '#F3F4F1',
  lightLine: '#DCDDD8',
  lightText: '#15171C',
  lightBody: '#3F444E',
};

export const fonts = {
  display: '"Archivo", "Helvetica Neue", Arial, sans-serif',
  body: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, Menlo, monospace',
};

export const CALENDLY_URL = 'https://calendly.com/aithisjob/15-minute-meeting';
export const CONTACT_EMAIL = 'dale@aithisjob.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/dale-arbogast/';

export default brand;
